import * as React from 'react'
import { Textarea } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'
import { OdinFormLabel } from '@/components/ui/odin/form/odin-form-label'
import { OdinFormDescription } from '@/components/ui/odin/form/odin-form-description'
import { OdinFormError } from '@/components/ui/odin/form/odin-form-error'

export type OdinTextareaProps = React.ComponentProps<'textarea'> & {
  label?: string
  description?: string
  error?: string
  required?: boolean
}

export function OdinTextarea({ className, label, description, error, required, id, placeholder, ...props }: OdinTextareaProps) {
  const reactId = React.useId()
  const textareaId = id || `textarea-${reactId}`
  const errorId = textareaId + '-error'
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label && (
        <OdinFormLabel htmlFor={textareaId} required={required}>
          {label}
        </OdinFormLabel>
      )}
      {description && <OdinFormDescription>{description}</OdinFormDescription>}
      <Textarea
        id={textareaId}
        className="px-3 py-2"
        placeholder={placeholder ?? label}
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        {...props}
      />
      <OdinFormError error={error} id={errorId} />
    </div>
  )
}
